import React from "react";

import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  Stack,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useTheme, darken } from "@mui/material/styles";

import { HelpBox } from "@/components/atoms";
import { StatementScore } from "@/types";
import { interpolateDivergant, toIndex, toPercentage } from "@/utils";

interface VariableCardProps {
  statement: StatementScore;
  score: string;
  minValue?: number;
  maxValue?: number;
}

const StatementCard: React.FC<VariableCardProps> = ({
  statement,
  score,
  minValue,
  maxValue,
}) => {
  const theme = useTheme();

  const value = Number(statement[score as keyof StatementScore]);

  const calcPercentage = (value: number) => {
    const mx = maxValue ? maxValue : 1;
    const mn = minValue ? minValue : 0;
    return Math.max(0.01, (value - mn) / (mx - mn));
  };

  const scoreColors = [
    theme.palette.score.dark,
    theme.palette.score.main,
    theme.palette.score.light
  ]
  const answers = ['Disagree', 'Neither Agree nor Disagree', 'Agree'];

  return (
    <Grid key={statement.name}>
      <Card
        sx={{
          border: 1,
          borderRadius: 1,
          borderColor: theme.palette.divider,
          width: "230px",
        }}
      >
        <CardContent
          sx={{
            pb: 2,
            "&:last-child": { pb: 2 },
          }}
        >
          <Stack spacing={2}>
            <HelpBox title={statement.name} placement="top">
              <Typography
                variant="body2"
                sx={{
                  height: "60px",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: "-webkit-box",
                  WebkitLineClamp: "3",
                  WebkitBoxOrient: "vertical",
                }}
              >
                {statement.name}
              </Typography>
            </HelpBox>
            {score === 'rate' ?
              <Stack direction="row" spacing={0}>
                {statement.rates.map((value, idx) => (
                  <HelpBox title={`${toPercentage(value)} ${answers[idx]}`} placement="top">
                    <Box
                      display="flex"
                      justifyContent="center"
                      width={toPercentage(value)}
                      borderRadius={
                        idx === 0
                          ? "4px 0px 0px 4px"
                          : idx === (statement.rates.length - 1)
                            ? "0px 4px 4px 0px"
                            : "0px 0px 0px 0px"
                      }
                      sx={{
                        backgroundColor: scoreColors[idx]
                      }}
                    >
                      <Typography
                        variant="caption"
                        sx={{
                          lineHeight: 1.5,
                          color: theme.palette.primary.contrastText
                        }}
                      >
                        {value >= 0.15 ? toPercentage(value): ''}
                      </Typography>
                    </Box>
                  </HelpBox>
                ))}
              </Stack>
              :
              <Stack
                direction="row"
                spacing={1}
                alignItems="center"
                justifyContent="space-between"
              >
                <Box
                  height="4px"
                  borderRadius="4px"
                  width={`${calcPercentage(value) * 100}%`}
                  sx={{
                    backgroundColor: interpolateDivergant(
                      theme.palette.score.light,
                      theme.palette.score.main,
                      theme.palette.score.dark,
                      1 - calcPercentage(value),
                    ),
                  }}
                />
                <Typography
                  variant="body2"
                  sx={{
                    color: interpolateDivergant(
                      theme.palette.score.light,
                      theme.palette.score.main,
                      theme.palette.score.dark,
                      1 - calcPercentage(value),
                    ),
                  }}
                >
                  {toIndex(value)}
                </Typography>
              </Stack>
            }
            {/*<Stack direction="row" spacing={0}>*/}
            {/*  {rates.map((value, idx) => (*/}
            {/*    <HelpBox title={`${toPercentage(value)} ${answers[idx]}`} placement="top">*/}
            {/*      <Box*/}
            {/*        display="flex"*/}
            {/*        justifyContent="center"*/}
            {/*        width={toPercentage(value)}*/}
            {/*        borderRadius={*/}
            {/*          idx === 0*/}
            {/*            ? "4px 0px 0px 4px"*/}
            {/*            : idx === (rates.length - 1)*/}
            {/*              ? "0px 4px 4px 0px"*/}
            {/*              : "0px 0px 0px 0px"*/}
            {/*        }*/}
            {/*        sx={{*/}
            {/*          backgroundColor: scoreColors[idx]*/}
            {/*        }}*/}
            {/*      >*/}
            {/*        <Typography*/}
            {/*          variant="caption"*/}
            {/*          sx={{*/}
            {/*            lineHeight: 1.5,*/}
            {/*            color: theme.palette.primary.contrastText*/}
            {/*          }}*/}
            {/*        >*/}
            {/*          {value >= 0.15 ? toPercentage(value): ''}*/}
            {/*        </Typography>*/}
            {/*      </Box>*/}
            {/*    </HelpBox>*/}
            {/*  ))}*/}
            {/*</Stack>*/}
            {/*<Stack*/}
            {/*  direction="row"*/}
            {/*  spacing={1}*/}
            {/*  alignItems="center"*/}
            {/*  justifyContent="space-between"*/}
            {/*>*/}
            {/*  <Box*/}
            {/*    height="4px"*/}
            {/*    borderRadius="4px"*/}
            {/*    width={`${calcPercentage(value) * 100}%`}*/}
            {/*    sx={{*/}
            {/*      backgroundColor: interpolateDivergant(*/}
            {/*        theme.palette.score.light,*/}
            {/*        theme.palette.score.main,*/}
            {/*        theme.palette.score.dark,*/}
            {/*        1 - calcPercentage(value),*/}
            {/*      ),*/}
            {/*    }}*/}
            {/*  />*/}
            {/*  <Typography*/}
            {/*    variant="body2"*/}
            {/*    sx={{*/}
            {/*      color: interpolateDivergant(*/}
            {/*        theme.palette.score.light,*/}
            {/*        theme.palette.score.main,*/}
            {/*        theme.palette.score.dark,*/}
            {/*        1 - calcPercentage(value),*/}
            {/*      ),*/}
            {/*    }}*/}
            {/*  >*/}
            {/*    {toIndex(value)}*/}
            {/*  </Typography>*/}
            {/*</Stack>*/}
          </Stack>
        </CardContent>
      </Card>
    </Grid>
  );
};

export default StatementCard;
